export const PROFILE_BUZZ_FILTERS = [
  "all",
  "posts",
  "sessions",
  "replies",
  "media",
  "stats",
] as const;

export type ProfileBuzzFilter = (typeof PROFILE_BUZZ_FILTERS)[number];
export type ProfileTab = "details" | "buzz";

export function resolveProfileNavigation(query: string) {
  const params = new URLSearchParams(query);
  const rawTab = params.get("tab");
  const tab: ProfileTab =
    rawTab === "buzz" || rawTab === "posts" || rawTab === "activities"
      ? "buzz"
      : "details";
  const rawFilter = params.get("filter");
  const filter: ProfileBuzzFilter =
    rawTab === "activities"
      ? "stats"
      : PROFILE_BUZZ_FILTERS.includes(rawFilter as ProfileBuzzFilter)
        ? (rawFilter as ProfileBuzzFilter)
        : "all";

  if (tab === "details") {
    params.delete("tab");
    params.delete("filter");
  } else {
    params.set("tab", "buzz");
    if (filter === "all") params.delete("filter");
    else params.set("filter", filter);
  }

  return {
    tab,
    filter: tab === "buzz" ? filter : "all",
    query: params.toString(),
  } as const;
}
